
import isJson from 'helpers/isJson';
import fontsList from 'components/Templates/fontsList';
import oldDraftToTiptap from './oldDraftToTiptap';
import getContent from 'components/Templates/general/getContent';



export default function getTextContent(props, isCompare) {

  const {
    typeOfStyle,
    componentPayload,
    language,
    defaultValues,
    windowWidth,
    content,
    standalone
  } = props;

  const thisLanguage = language ? language : 'en';


  const thisContent = content ? content : componentPayload?.content && componentPayload.content[typeOfStyle] ? componentPayload.content : defaultValues;


  const getValue = getContent({
    typeOfStyle: typeOfStyle ? typeOfStyle : componentPayload?.typeOfStyle ? componentPayload.typeOfStyle : '',
    windowWidth: windowWidth,
    language: thisLanguage,
    content: thisContent,
    standalone: standalone
  });

  if (isCompare) return getValue && getValue.value ? getValue.value : null;


  const getStateValue = getValue && getValue.value ? isJson(getValue.value) : '';
  const getHtmlValue = getValue && getValue.value ? getValue.value : ''

  const rawInitalState = getStateValue 
    ? getStateValue 
    : getHtmlValue;

  const fontFamilies = fontsList.map((font) => {
    return { value: font.name, title: `${font.name}, ${font.fallback}` }
  });

  const initialEditorState = getStateValue ? getStateValue.type && getStateValue.type === 'doc' ? rawInitalState : oldDraftToTiptap(fontFamilies, rawInitalState) : rawInitalState;


  return {
    editorState: initialEditorState,
    content: getValue && getValue.value ? getValue.value : null
  };
}
